export default __webpack_public_path__ + "static/swim-e92401260cd6cc5a077aad9058edd91e.webp";